// removed by extract-text-webpack-plugin
module.exports = {"content":"content__2ljsH","collapsed":"collapsed__1ZNWl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarContainer/styles.scss
// module id = 2153
// module chunks = 1